var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Component from '@arco-design/web-react/es/Input/input';
import ErrorTip from './error-tip';
import cx from 'classnames';
import { useConfigContext } from '../config-provider';
var InputBasic = function (props, ref) {
    var error = props.error, errorTip = props.errorTip, errorWrapperStyle = props.errorWrapperStyle, errorWrapperCls = props.errorWrapperCls, rest = __rest(props, ["error", "errorTip", "errorWrapperStyle", "errorWrapperCls"]);
    var common = useConfigContext().prefixCls;
    var prefixCls = common + "-input";
    return React.createElement("div", { className: cx(prefixCls, errorWrapperCls), style: errorWrapperStyle },
        React.createElement(Component, __assign({}, rest, { error: error, ref: ref })),
        React.createElement(ErrorTip, { show: error }, errorTip));
};
var SearchBasic = function (props, ref) {
    var error = props.error, errorTip = props.errorTip, errorWrapperStyle = props.errorWrapperStyle, errorWrapperCls = props.errorWrapperCls, rest = __rest(props, ["error", "errorTip", "errorWrapperStyle", "errorWrapperCls"]);
    var common = useConfigContext().prefixCls;
    var prefixCls = common + "-input";
    return React.createElement("div", { className: cx(prefixCls, errorWrapperCls), style: errorWrapperStyle },
        React.createElement(Component.Search, __assign({}, rest, { error: error, ref: ref })),
        React.createElement(ErrorTip, { show: error }, errorTip));
};
var TextAreaBasic = function (props, ref) {
    var error = props.error, errorTip = props.errorTip, errorWrapperStyle = props.errorWrapperStyle, errorWrapperCls = props.errorWrapperCls, disabled = props.disabled, rest = __rest(props, ["error", "errorTip", "errorWrapperStyle", "errorWrapperCls", "disabled"]);
    var common = useConfigContext().prefixCls;
    var prefixCls = common + "-input";
    var statusCls = error ? prefixCls + "-error" : disabled ? prefixCls + "-disabled" : '';
    return React.createElement("div", { className: cx(prefixCls, errorWrapperCls, statusCls), style: errorWrapperStyle },
        React.createElement(Component.TextArea, __assign({}, rest, { disabled: disabled, error: error, ref: ref })),
        React.createElement(ErrorTip, { show: error }, errorTip));
};
var PasswordBasic = function (props, ref) {
    var error = props.error, errorTip = props.errorTip, errorWrapperStyle = props.errorWrapperStyle, errorWrapperCls = props.errorWrapperCls, rest = __rest(props, ["error", "errorTip", "errorWrapperStyle", "errorWrapperCls"]);
    var common = useConfigContext().prefixCls;
    var prefixCls = common + "-input";
    return React.createElement("div", { className: cx(prefixCls, errorWrapperCls), style: errorWrapperStyle },
        React.createElement(Component.Password, __assign({}, rest, { error: error, ref: ref })),
        React.createElement(ErrorTip, { show: error }, errorTip));
};
var InputComponent = React.forwardRef(InputBasic);
InputComponent.Search = React.forwardRef(SearchBasic);
InputComponent.TextArea = React.forwardRef(TextAreaBasic);
InputComponent.Password = React.forwardRef(PasswordBasic);
InputComponent.displayName = 'Input';
export default InputComponent;
//# sourceMappingURL=index.js.map